'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Track } from 'livekit-client';
import { MicrophoneIcon, MicrophoneSlashIcon, MonitorArrowUpIcon, SpinnerIcon, VideoCameraIcon, VideoCameraSlashIcon, } from '@phosphor-icons/react/dist/ssr';
import { Toggle } from '@/components/ui/toggle';
import { cn } from '@/lib/utils';
function getSourceIcon(source, enabled, pending = false) {
    if (pending) {
        return SpinnerIcon;
    }
    switch (source) {
        case Track.Source.Microphone:
            return enabled ? MicrophoneIcon : MicrophoneSlashIcon;
        case Track.Source.Camera:
            return enabled ? VideoCameraIcon : VideoCameraSlashIcon;
        case Track.Source.ScreenShare:
            return MonitorArrowUpIcon;
        default:
            return React.Fragment;
    }
}
function getSourceLabel(source) {
    switch (source) {
        case Track.Source.Microphone:
            return 'Uključi/isključi mikrofon';
        case Track.Source.Camera:
            return 'Uključi/isključi kameru';
        case Track.Source.ScreenShare:
            return 'Uključi/isključi deljenje ekrana';
        default:
            return 'Uključi/isključi';
    }
}
export function TrackToggle(_a) {
    var { source, pressed, pending, className } = _a, props = __rest(_a, ["source", "pressed", "pending", "className"]);
    const IconComponent = getSourceIcon(source, pressed !== null && pressed !== void 0 ? pressed : false, pending);
    return (_jsxs(Toggle, Object.assign({ pressed: pressed, "aria-label": getSourceLabel(source), className: cn(className) }, props, { children: [_jsx(IconComponent, { weight: "bold", className: cn(pending && 'animate-spin') }), props.children] })));
}
